import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function mediaUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  // Route soloenduro.it images via wsrv.nl proxy (CF bypass) so they load reliably
  if (pathOrUrl.includes("soloenduro.it/wp-content/")) {
    return `https://wsrv.nl/?url=${encodeURIComponent(pathOrUrl)}`;
  }
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/media/")) return `${BACKEND_URL}${pathOrUrl}`;
  // Frontend absolute public path (e.g., /news/foo.jpg, /showroom/x.jpg)
  if (pathOrUrl.startsWith("/")) return pathOrUrl;
  return `${API_BASE}/media/${pathOrUrl}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
